
    <fieldmagic-dialog
      label="Output"
      icon="file"
      [instance]="self">

      <div class="dialog-header-buttons">
        <fieldmagic-dialog-close-button
          (click)="dialog.close()"
        ></fieldmagic-dialog-close-button>
      </div>
      <ng-template fieldmagicDialogContentTmp>
        <iframe
        frameBorder="0"
        [attr.srcdoc]="data"
        height="700px"
        width="800px"
        ></iframe>
      </ng-template>
    </fieldmagic-dialog>

  